<template>
	<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">
		<h4 v-if="delivery.contact && (delivery.delivery_type_id == $constants.delivery.UITDIENST || delivery.delivery_type_id == $constants.delivery.BULK_LEVERING)">{{ delivery.delivery_type.name }} van {{ delivery.contact }}</h4>
		<h4 v-else>{{ delivery.delivery_type.name }} van {{ delivery.client.contacts[0] ? delivery.client.contacts[0].first_name + ' ' + delivery.client.contacts[0].last_name : delivery.client.name }}</h4>

		<div class="fs-small color-gray-500 margin-b-16" v-if="delivery.user">Aangevraagd door {{ delivery.user.name }} </div>

		<c-splitbutton class="margin-b-24" :buttons="buttons" v-if="!deliveryIsCancelled && delivery.delivery_type_id !== $constants.delivery.MUTATIE"></c-splitbutton>

		<c-splitbutton class="margin-b-24" :buttons="cancelledButtons" v-if="deliveryIsCancelled"></c-splitbutton>

        <div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Eindklant</span>
			</div>
			<div class="columns small-12 medium-8">
			{{delivery.client.client_type_id == $constants.client.EINDGEBRUIKER && delivery.client.parent ? delivery.client.parent.name : delivery.client.name }}
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Aanmeld datum</span>
			</div>
			<div class="columns small-12 medium-8">
				{{datetime(delivery.created_at, true)}}
				<!-- {{delivery.date | datestring}} -->
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Datum</span>
			</div>
			<div class="columns small-12 medium-8">
				{{datetime(delivery.date, false)}}
				<!-- {{delivery.date | datestring}} -->
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Type</span>
			</div>
			<div class="columns small-12 medium-8">
				{{delivery.delivery_type.name}}
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall" v-if="delivery.contact && (delivery.delivery_type_id == $constants.delivery.UITDIENST || delivery.delivery_type_id == $constants.delivery.BULK_LEVERING)">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Contactpersoon</span>
			</div>
			<div class="columns small-12 medium-8">
				{{delivery.contact}}
			</div>
		</div>

		<div v-if="delivery.delivery_type_id !== $constants.delivery.BULK_LEVERING">
			<div v-for="contact in delivery.client.contacts" :key="contact.id">
				<div class="row margin-b-16 fs-xsmall" v-if="contact.firstname">
					<div class="columns small-12 medium-4">
						<span class="color-gray-600 font-heading">Eindgebruiker</span>
					</div>
					<div class="columns small-12 medium-8">
						{{contact.first_name}} {{contact.last_name}}
					</div>
				</div>

				<div class="row margin-b-16 fs-xsmall">
					<div class="columns small-12 medium-4">
						<span class="color-gray-600 font-heading">Functie</span>
					</div>
					<div class="columns small-12 medium-8">
						{{contact.title}}
					</div>
				</div>

				<div class="row margin-b-16 fs-xsmall">
					<div class="columns small-12 medium-4">
						<span class="color-gray-600 font-heading">Telefoonnummer</span>
					</div>
					<div class="columns small-12 medium-8">
						{{contact.phone}}
					</div>
				</div>

				<div class="row margin-b-16 fs-xsmall">
					<div class="columns small-12 medium-4">
						<span class="color-gray-600 font-heading">E-mailadres</span>
					</div>
					<div class="columns small-12 medium-8">
						{{contact.email}}
					</div>
				</div>
			</div>
		</div>
		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Adres</span>
			</div>
			<div class="columns small-12 medium-8">
				{{$filter.address(delivery.address) }}
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall" v-if="delivery.delivery_type_id !== $constants.delivery.MUTATIE">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Bezorgdienst</span>
			</div>
			<div class="columns small-12 medium-8" v-if="delivery.carrier">
					{{delivery.carrier.name}} <a @click="trigger('change-carrier')">wijzigen</a>
			</div>
		</div>

		<div v-if="delivery.delivery_type_id == $constants.delivery.REPARATIE || delivery.delivery_type_id == $constants.delivery.EOL_SWAP">
			<div class="row margin-b-16 fs-xsmall" >
				<div class="columns small-12 medium-4">
					<span class="color-gray-600 font-heading">{{delivery.delivery_type_id == $constants.delivery.REPARATIE ? "Defect artikel" : "EOL artikel"}}</span>
				</div>
				<div class="columns small-12 medium-8" >
					<div v-for="product in delivery.products" :key="product.id">
						<div v-if="product.pickup.is_pickup == 1">
						{{product.name}}<br>
						</div>
					</div>
				</div>
			</div>
			<div class="row margin-b-16 fs-xsmall" >
				<div class="columns small-12 medium-4">
					<span class="color-gray-600 font-heading">Vervangend artikel</span>
				</div>
				<div class="columns small-12 medium-8" >
					<div v-for="product in delivery.products" :key="product.id">
						<div v-if="product.pickup.is_pickup == 0">
						{{product.name}} <br>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else-if="delivery.delivery_type_id == $constants.delivery.BACKORDER">
			<div class="row margin-b-16 fs-xsmall">
				<div class="columns small-12 medium-4">
					<span class="color-gray-600 font-heading">Op te halen artikel</span>
				</div>
				<div class="columns small-12 medium-8" >
					<div v-for="product in delivery.products" :key="product.id">
						<div v-if="product.pickup.is_pickup == 1">
						{{product.name}}<br>
						</div>
					</div>
				</div>
			</div>
			<div class="row margin-b-16 fs-xsmall" >
				<div class="columns small-12 medium-4">
					<span class="color-gray-600 font-heading">Te bezorgen artikel</span>
				</div>
				<div class="columns small-12 medium-8" >
					<div v-for="product in delivery.products" :key="product.id">
						<div v-if="product.pickup.is_pickup == 0">
						{{product.name}} <br>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else-if="delivery.delivery_type_id == $constants.delivery.MUTATIE">
			<div class="row margin-b-16 fs-xsmall">
				<div class="columns small-12 medium-4">
					<span class="color-gray-600 font-heading">Mutatie</span>
				</div>
				<div class="columns small-12 medium-8">
					{{delivery.items[0].product.name}}
				</div>
			</div>
			<div class="row margin-b-16 fs-xsmall">
				<div class="columns small-12 medium-4">
					<span class="color-gray-600 font-heading">Serienummer</span>
				</div>
				<div class="columns small-12 medium-8">
					{{delivery.items[0].serial}} 
				</div>
			</div>
			<div class="row margin-b-16 fs-xsmall">
				<div class="columns small-12 medium-4">
					<span class="color-gray-600 font-heading">Artikel ID</span>
				</div>
				<div class="columns small-12 medium-8">
					{{ delivery.items[0].id }}
				</div>
			</div>
		</div>
		<div class="row margin-b-16 fs-xsmall" v-else>
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Voorraad</span>
			</div>
			<div class="columns small-12 medium-8" v-if="delivery.delivery_type_id == $constants.delivery.INDIENST || delivery.delivery_type_id == $constants.delivery.UITDIENST || delivery.delivery_type_id == $constants.delivery.EXTRA_PRODUCTEN || delivery.delivery_type_id == $constants.delivery.BACKORDER">
				<div v-for="product in delivery.products" :key="product.id">
					{{product.name}}<br>
				</div>
			</div>
			<div class="columns small-12 medium-8" v-if="delivery.delivery_type_id == $constants.delivery.BULK_LEVERING">
				<div v-for="product in productList" :key="product.id">
					{{product.expected}}x {{product.name}}<br>
				</div>
			</div>
		</div>
	
        <div class="row margin-b-16 fs-xsmall">
            <div class="columns small-12 medium-4">
                <span class="color-gray-600 font-heading">Topdesk nummer</span>
            </div>
            <div class="columns small-12 medium-8">
                {{delivery.w_number}}
            </div>
        </div>
		<div class="row margin-b-16 fs-xsmall" v-if="delivery.delivery_type_id !== $constants.delivery.MUTATIE">
            <div class="columns small-12 medium-4">
                <span class="color-gray-600 font-heading">Opmerking</span>
            </div>
            <div class="columns small-12 medium-8">
                {{delivery.description}}
            </div>
        </div>
		<div class="row margin-b-16 fs-xsmall" v-if="delivery.delivery_type_id == $constants.delivery.BULK_LEVERING">
            <div class="columns small-12 medium-4">
                <span class="color-gray-600 font-heading">Bestand</span>
            </div>
            <div class="columns small-12 medium-8" v-if="delivery.media[0]">
                <a download :href="delivery.media[0].original_url">{{delivery.media[0].name}}</a>
            </div>
        </div>
	</div>

</template>

<script>
import CSplitbutton from '@components/Splitbutton';
import { mapGetters } from 'vuex';
import Form from '@mixins/Form';

export default {
	mixins: [Form],

	components: { CSplitbutton },
	props:{
		delivery: {
			required: true
		},
		productList: {
			required: false
		}
	},
	methods: {
		datetime(value, hours = false){
			if ( typeof value == 'string' && value.trim() != '' ) {
				let date = new Date(value);

				if ( isNaN(date.getTime()) === false ) {

					if(hours){
						return date.toLocaleDateString('nl-NL', {day: 'numeric', month:'numeric', year: 'numeric',  hour: 'numeric', minute: 'numeric', hour12: false})
					}
					else {
						return date.toLocaleDateString('nl-NL', {day: 'numeric', month:'numeric', year: 'numeric'})
					}
				}
    		}
		},
		trigger(event) {
			this.$store.dispatch('listener/emit', event);
		},
	},
	computed: {
		...mapGetters({
			can: 'user/can',
		}),
        cancelledButtons() {
            let buttons = [];

            this.can('Levering verwijderen') && buttons.push({
                label: 'Geannuleerd',
                action: () => {}
            });
            this.can('Levering wijzigen') && buttons.push({
                label: 'Toch leveren',
                action: () => {
                    this.$store.dispatch('listener/emit', 'reopen-cancelled-delivery');
                }
            });
            this.can('Levering verwijderen') && buttons.push({
                label: 'Verwijderen',
                action: () => {
                    this.$store.dispatch('listener/emit', 'delete-delivery');
                }
            });

            return buttons;
        },
		buttons() {

			let buttons = [];
			this.can('Levering wijzigen') && buttons.push({
				label: 'Bewerken',
				action: () => {
						if(this.delivery.delivery_type_id === this.$constants.delivery.REPARATIE){
							this.$store.dispatch('listener/emit', 'repair');
						}
						else if(this.delivery.delivery_type_id === this.$constants.delivery.UITDIENST){
							this.$store.dispatch('listener/emit', 'resignation');
						}
						else if(this.delivery.delivery_type_id === this.$constants.delivery.INDIENST){
							this.$store.dispatch('listener/emit', 'new-reseller');
						}
						else if(this.delivery.delivery_type_id === this.$constants.delivery.EOL_SWAP){
							this.$store.dispatch('listener/emit', 'eol-swap');
						}
						else if(this.delivery.delivery_type_id === this.$constants.delivery.EXTRA_PRODUCTEN){
							this.$store.dispatch('listener/emit', 'extra-products');
						}
						else if(this.delivery.delivery_type_id === this.$constants.delivery.BULK_LEVERING){
							this.$store.dispatch('listener/emit', 'bulk-order');
						}
				},
			});

            if (!this.delivery.finished || (this.delivery.delivery_type_id === this.$constants.delivery.UITDIENST && this.delivery.completed == null)) {
                this.can('Levering verwijderen') && buttons.push({
                    label: 'Annuleren',
                    action: () => {
                        this.$store.dispatch('listener/emit', 'cancel-delivery');
                    }
                });  
            }

			return buttons;
		},
        deliveryIsCancelled() {
            return !!this.delivery.is_cancelled;
        }

	},

}
</script>
